var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6042 12.5636C20.7292 12.6659 20.882 12.7097 21.0279 12.7097C21.2362 12.7097 21.4446 12.6147 21.5766 12.4247C21.8127 12.1103 21.7571 11.6498 21.4515 11.4013L12.4228 4.09168C12.1727 3.89432 11.8255 3.89432 11.5754 4.09168L2.54666 11.4013C2.24107 11.6498 2.18551 12.1103 2.42165 12.4247C2.65083 12.7463 3.08839 12.8048 3.39398 12.5635L4.42881 11.7229V19.9974H4.35936C3.97736 19.9974 3.66483 20.3263 3.66483 20.7284C3.66483 21.1377 3.97736 21.4593 4.35936 21.4593H5.11637C5.12332 21.4593 5.12332 21.4667 5.12332 21.4667H9.22111C9.22111 21.4667 9.22111 21.4593 9.22805 21.4593H19.639C20.021 21.4593 20.3335 21.1377 20.3335 20.7284C20.3335 20.3263 20.021 19.9974 19.639 19.9974H19.5695V11.7229L20.6042 12.5636ZM14.7771 15.4874H12.6936V17.6803C12.6936 18.0823 12.381 18.4113 11.9991 18.4113C11.6101 18.4113 11.3045 18.0823 11.3045 17.6803V15.4874H9.22096C8.83203 15.4874 8.52644 15.1585 8.52644 14.7564C8.52644 14.3544 8.83203 14.0255 9.22096 14.0255H11.3045V11.8326C11.3045 11.4306 11.6101 11.1016 11.9991 11.1016C12.381 11.1016 12.6936 11.4306 12.6936 11.8326V14.0255H14.7771C15.1591 14.0255 15.4717 14.3544 15.4717 14.7564C15.4717 15.1585 15.1591 15.4874 14.7771 15.4874Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.50391,
    y: 14.0208,
    width: 6.97266,
    height: 1.46973,
    rx: 0.734863,
    fill: "transperent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7246,
    y: 11.1087,
    width: 7.29492,
    height: 1.46973,
    rx: 0.734863,
    transform: "rotate(90 12.7246 11.1087)",
    fill: "transperent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashHome);
export default __webpack_public_path__ + "static/media/dash-home.32871da24d1304f5957db1cfcaf4773f.svg";
export { ForwardRef as ReactComponent };